import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonService } from "../../../shared/services/common.service";
import {
  FetchSessionDeliveryFilterModel
} from "../models/fetch-session-delivery-filter.model";
import {
  FetchSessionResourcesModel
} from "../models/fetch-session-resources.model";
import {
  UpdateSessionDetailsModel
} from "../models/update-session-details.model";
import { FetchCoachesFilterModel } from "../models/fetch-coaches-filter.model";
import { FetchSessionDetailsModel } from "../models/fetch-session-details.model";
import {
  FetchSessionListModel
} from "../../group-details/models/fetch-session-list.model";
import { v1URL } from "../../../shared/constants/urls.constants";
import {
  FetchParticipantAttendanceModel
} from "../models/fetch-participant-attendance.model";

@Injectable({
  providedIn: "root",
})

export class SessionsListService {
  constructor(private commonServices: CommonService) {
  }

  fetchSessionDeliveryFilter(): Observable<FetchSessionDeliveryFilterModel["response"]> {
    const urlConfig = v1URL.filters.groupType;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchSessionResources(payload: FetchSessionResourcesModel["request"]): Observable<FetchSessionResourcesModel["response"]> {
    const urlConfig = v1URL.resourceHub.relatedResources;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  updateSessionDetails(payload: UpdateSessionDetailsModel["request"]): Observable<UpdateSessionDetailsModel["response"]> {
    const params: any = {
      groupId: payload?.groupId,
      sessionId: payload?.sessionId
    }
    const updatedPayload = {
      ...payload
    }
    delete updatedPayload?.groupId
    delete updatedPayload?.sessionId

    const urlConfig = v1URL.groups.sessions.details.edit;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(params), updatedPayload);
  }

  fetchSessionDetails(payload: FetchSessionDetailsModel['request']): Observable<FetchSessionDetailsModel["response"]> {
    const urlConfig = v1URL.groups.sessions.details.fetch;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchCoachesFilter(payload): Observable<FetchCoachesFilterModel["response"]> {
    const urlConfig = v1URL.filters.coaches;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchSessionList(payload: FetchSessionListModel['request']): Observable<FetchSessionListModel['response']> {
    const urlConfig = v1URL.groups.sessions.fetch
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchParticipantAttendance(payload: FetchParticipantAttendanceModel['request']): Observable<FetchSessionListModel['response']> {
    const urlConfig = v1URL.groups.sessions.attendance.fetch
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  markAttendance(payload): Observable<any> {
    const params: any = {
      groupId: payload?.groupId,
      sessionId: payload?.sessionId
    }
    const updatedPayload = {
      ...payload
    }

    delete updatedPayload?.groupId
    delete updatedPayload?.sessionId

    const urlConfig = v1URL.groups.sessions.attendance.edit
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(params), updatedPayload);
  }

  markParticipantDropout(payload: { userId: any, groupId: any, status: any }): Observable<any> {
    const urlConfig = v1URL.groups.markDropout
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  generateVisitNotesReports(payload: {
    sessionId: string, groupId: string, forUserId: string
  }): Observable<any> {
    const urlConfig = v1URL.groups.sessions.visitNotesReports
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }

}
